import { post } from './http'

const baseUrl = '/api/meas/admin/resource/campus'

// 获取校区列表
export const getCampusList = data => post(`${baseUrl}/getCampusList`, data)

// 新增编辑校区
export const saveCampus = data => post(`${baseUrl}/saveCampus`, data)

// 获取校区详情
export const getCampusDetails = data => post(`${baseUrl}/getCampusDetails`, data)

// 删除校区 
export const updateCampusStatus = data => post(`${baseUrl}/updateCampusStatus`, data)